/* eslint-disable no-restricted-syntax */

import switchModal from '@/components/generics/modal/switch/switch.vue';
import marketContractsStats from '@/components/market/market-contracts-stats/market-contracts-stats.vue';

export default {
  components: {
    marketContractsStats,
    switchModal,
  },
  props: {
    stats: {
      type: Array,
      required: true,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classModifiers() {
      return {
        'market-contracts-stats-popup__content': true,
        'market-contracts-stats-popup__content--long': this.stats.length > 5,
      };
    },
  },
  methods: {
    close() {
      this.$emit('modalClose');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contracts-stats-popup/market-contracts-stats-popup.js